import { createFileRoute } from '@tanstack/react-router';
import { createCaslGuard } from '@/lib/auth/permissionGuards';

import { UserManagementPage } from '@/pages/organization-settings/user-management/UserManagementPage';

export const Route = createFileRoute('/$slug/organization-settings/user-management')({
  beforeLoad: createCaslGuard('OrgSettings'),
  component: UserManagementPage
});
